export function getLoginUrl() {
  const loginUrl = `${window.location.origin}/login`;
  const redirect = encodeURIComponent(window.location.href);
  return `${loginUrl}?redirect=${redirect}`;
}

export function doSsoLogin(type: 'cas' | 'passport', redirect: string) {
  const baseUrl = process.env.VUE_APP_BASE_URL;
  // window.location.href = `${baseUrl}/sso/login?mode=${type}&followup=${redirect}`;
  console.log(
    'doSsoLogin= ',
    `${baseUrl}/nr-qiankun-center/sso/passport/login?followup=${redirect}`
  );
  window.location.href = `${baseUrl}/nr-qiankun-center/sso/passport/login?followup=${redirect}`;
}

export function doSsoLogout() {
  const loginUrl = getLoginUrl();
  const baseUrl = process.env.VUE_APP_BASE_URL;
  // window.location.href = `${baseUrl}/sso/logout?followup=${encodeURIComponent(loginUrl)}`;
  window.location.href = `${baseUrl}/nr-qiankun-center/sso/passport/login?followup=${loginUrl}`;
}
